import { getThumbnailProps } from '../../../utils/youtubeUtils';
import { TProductImageProps } from '../../@shared/picture/types/picture.types';
import { TInnerCardProps } from '../types/productSeriesDetailFeature.types';

export class InnerCardModel {
  public readonly fields?: TInnerCardProps;
  constructor(props) {
    this.fields = props;
  }

  get component() {
    return this.fields?.component;
  }

  get assets() {
    return this.component?.assets;
  }

  get title() {
    return this.component?.title;
  }

  get description() {
    return this.component?.description;
  }

  get button1() {
    return this.component?.button1;
  }

  get button2() {
    return this.component?.button2;
  }

  get firstAsset() {
    return this.assets?.[0];
  }

  get pictureProps(): TProductImageProps {
    switch (this.fields?.cardsCount) {
      case 1:
      case 2:
        return {
          desktopRendition: this.firstAsset?.rendition_desktop_size1200,
          mobileRendition: this.firstAsset?.rendition_mobile_size500,
        };
      case 3:
        return {
          desktopRendition: this.firstAsset?.rendition_desktop_size1000,
          mobileRendition: this.firstAsset?.rendition_mobile_size500,
        };
      default:
        return {
          desktopRendition: this.firstAsset?.rendition_desktop_size500,
          mobileRendition: this.firstAsset?.rendition_mobile_size500,
        };
    }
  }

  get bannerType(): 'video' | 'image' {
    if (this.firstAsset?.role === 'video' || this.firstAsset?.role === 'extvideo') {
      return 'video';
    }
    return 'image';
  }

  get videoUrl() {
    if (this.firstAsset?.role === 'video' || this.firstAsset?.role === 'extvideo') {
      return this.firstAsset.full || '';
    }
    return '';
  }

  get videoThumbnail() {
    if (this.firstAsset?.role === 'extvideo') {
      const { showThumbnail, thumbnailImgSrc } = getThumbnailProps(this.firstAsset?.full);
      return {
        showThumbnail,
        editorialImageProps: {
          desktopImage: thumbnailImgSrc,
          mobileImage: thumbnailImgSrc,
          alt: this.description || '',
        },
      };
    }
    if (this.firstAsset?.role === 'video') {
      return {
        showThumbnail: !!this.firstAsset?.bigthumbnail,
        editorialImageProps: {
          desktopImage: this.firstAsset?.bigthumbnail,
          mobileImage: this.firstAsset?.bigthumbnail,
          alt: this.firstAsset?.alt || '',
        },
      };
    }
    return {
      showThumbnail: false,
      editorialImageProps: undefined,
    };
  }

  get showThumbnail() {
    return this.videoThumbnail.showThumbnail;
  }

  get editorialImageProps() {
    return this.videoThumbnail.editorialImageProps;
  }
}
